
import { z } from 'zod';

const MAX_FILE_SIZE = 5000000; // 5MB
const ACCEPTED_IMAGE_TYPES = ["image/jpeg", "image/jpg", "image/png", "image/webp", "image/svg+xml"];

export const createSchoolSchema = z.object({
    schoolName: z.string().min(1, { message: "School name is required" }),
    schoolEmail: z.email({ message: "Invalid email address" }),
    schoolContact: z.string().min(1, { message: "School contact is required" }),
    address: z.string().min(1, { message: "Address is required" }),
    country: z.string().min(1, { message: "Country is required" }),

    adminName: z.string().min(1, { message: "Admin name is required" }),
    adminUsername: z.string().min(1, { message: "Admin username is required" }),
    adminEmail: z.email({ message: "Invalid email address" }),

    principalName: z.string().min(1, { message: "Principal name is required" }),
    principalContact: z.string().min(1, { message: "Principal contact is required" }),
    principalEmail: z.email({ message: "Invalid email address" }),

    logo: z
        .custom<File>((val) => val instanceof File, "Please upload a logo")
        .refine((file) => file.size <= MAX_FILE_SIZE, `Max file size is 5MB.`)
        .refine(
            (file) => ACCEPTED_IMAGE_TYPES.includes(file.type),
            "Only .jpg, .jpeg, .png, .webp and .svg formats are supported."
        )
        .optional(),

    website_url: z.url("Invalid Website link").optional().or(z.literal("")),
    linkedin_link: z.url("Invalid LinkedIn link").optional().or(z.literal("")),
    instagram_link: z.url("Invalid Instagram link").optional().or(z.literal("")),
    youtube_link: z.url("Invalid YouTube link").optional().or(z.literal("")),
    facebook_link: z.url("Invalid Facebook link").optional().or(z.literal("")),

    device_limit: z.coerce.number().min(0, { message: "Device limit is required and must be 0 or higher" }),
    device_expiry: z.string().min(1, { message: "License expiry date is required" }),
});

export type CreateSchoolFormValues = z.infer<typeof createSchoolSchema>;
